import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Grid } from "swiper/modules";
import type { Swiper as SwiperType } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/navigation";
import * as S from "./styles";

interface ChannelCarouselProps {
  onChannelSelect: (url: string) => void;
  currentUrl: string;
}

interface Channel {
  name: string;
  url: string;
  logo: string;
}

const channels: Channel[] = [
  {
    name: "Band Sports",
    url: "https://01.multicanaistv.win/bandsport/index.m3u8",
    logo: "/logos/bandsports.png",
  },
  {
    name: "ESPN",
    url: "https://02.multicanaistv.win/espn/index.m3u8",
    logo: "/logos/espn.png",
  },
  {
    name: "ESPN 2",
    url: "https://03.multicanaistv.win/espn2/index.m3u8",
    logo: "/logos/espn2.png",
  },
  {
    name: "ESPN 3",
    url: "https://03multicanaistv.win/espn3/index.m3u8",
    logo: "/logos/espn3.png",
  },
  {
    name: "ESPN 4",
    url: "https://02.multicanaistv.win/espn4/index.m3u8",
    logo: "/logos/espn4.png",
  },
  {
    name: "SporTV",
    url: "https://01.multicanaistv.win/sportv/index.m3u8",
    logo: "/logos/sportv.png",
  },
  {
    name: "SporTV 2",
    url: "https://03.multicanaistv.win/sportv2/index.m3u8",
    logo: "/logos/sportv2.png",
  },
  {
    name: "SporTV 3",
    url: "https://01.multicanaistv.win/sportv3/index.m3u8",
    logo: "/logos/sportv3.png",
  },
  {
    name: "Playboy",
    url: "https://02.multicanaistv.win/playboy/index.m3u8",
    logo: "/logos/playboy.png",
  },
  {
    name: "Premiere 1",
    url: "https://01.multicanaistv.win/pre1/index.m3u8",
    logo: "/logos/premiere.png",
  },
  {
    name: "Premiere 2",
    url: "https://01.multicanaistv.win/pre2/index.m3u8",
    logo: "/logos/premiere2.png",
  },
  {
    name: "Premiere 3",
    url: "https://01.multicanaistv.win/pre3/index.m3u8",
    logo: "/logos/premiere3.png",
  },
  {
    name: "Premiere 4",
    url: "https://01.multicanaistv.win/pre4/index.m3u8",
    logo: "/logos/premiere4.png",
  },
  {
    name: "Premiere 5",
    url: "https://01.multicanaistv.win/pre5/index.m3u8",
    logo: "/logos/premiere5.png",
  },
  {
    name: "Premiere 6",
    url: "https://01.multicanaistv.win/pre6/index.m3u8",
    logo: "/logos/premiere6.png",
  },
  {
    name: "Premiere 7",
    url: "https://01.multicanaistv.win/pre7/index.m3u8",
    logo: "/logos/premiere7.png",
  },
  {
    name: "Premiere 8",
    url: "https://01.multicanaistv.win/pre8/index.m3u8",
    logo: "/logos/premiere8.png",
  },
  {
    name: "Sexy Hot",
    url: "https://02.multicanaistv.win/sexhot/index.m3u8",
    logo: "/logos/sexyhot.png",
  },
];

const ChannelCarousel: React.FC<ChannelCarouselProps> = ({
  onChannelSelect,
  currentUrl,
}) => {
  const swiperRef = useRef<SwiperType | null>(null);

  return (
    <S.CarouselContainer>
      <S.NavigationButton
        position="left"
        onClick={() => swiperRef.current?.slidePrev()}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </S.NavigationButton>

      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        modules={[Navigation, Grid]}
        spaceBetween={10}
        slidesPerView={6}
        grid={{
          rows: 2,
          fill: "row",
        }}
        navigation={false}
        breakpoints={{
          320: {
            slidesPerView: 2,
            grid: {
              rows: 2,
            },
          },
          640: {
            slidesPerView: 4,
            grid: {
              rows: 2,
            },
          },
          1024: {
            slidesPerView: 6,
            grid: {
              rows: 2,
            },
          },
        }}
        className="mySwiper"
      >
        {channels.map((channel) => (
          <SwiperSlide key={channel.url}>
            <S.ChannelCard
              isActive={currentUrl === channel.url}
              onClick={() => onChannelSelect(channel.url)}
            >
              <S.ChannelLogoContainer>
                <S.ChannelLogo
                  src={channel.logo}
                  alt={channel.name}
                  onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                    // Fallback para texto se a imagem não carregar
                    e.currentTarget.style.display = "none";
                    if (e.currentTarget.parentElement) {
                      e.currentTarget.parentElement.innerHTML = `<span style="color: white; font-weight: bold;">${channel.name}</span>`;
                    }
                  }}
                />
              </S.ChannelLogoContainer>
            </S.ChannelCard>
          </SwiperSlide>
        ))}
      </Swiper>

      <S.NavigationButton
        position="right"
        onClick={() => swiperRef.current?.slideNext()}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </S.NavigationButton>
    </S.CarouselContainer>
  );
};

export default ChannelCarousel; 